import React, { useState } from 'react';
import { get, uniqueId } from 'lodash';
import { ForgeIcon, ForgeTooltip } from '@tylertech/forge-react';
import getScopedTranslateMethod from 'common/js_utils/getScopedTranslateMethod';
import { ScanResult, ScanStatus } from 'common/core/file_scan';

const t = getScopedTranslateMethod('shared.scan_result');

interface Props {
  result: ScanResult;
}

interface StatusIconMapValues {
  icon: string;
  tKey: string;
  style?: string;
}
type StatusIconMap = (
  Record<ScanStatus, StatusIconMapValues> &
  Record<'default', StatusIconMapValues>
);

// This is exported for testing purposes
export const statusIconMap: StatusIconMap = {
  [ScanStatus.Ok]: { icon: 'shield_check_outline', tKey: 'secure', style: 'success' },
  [ScanStatus.Bad]: { icon: 'shield_alert_outline', tKey: 'bad' },
  [ScanStatus.TooLarge]: { icon: 'shield_off_outline', tKey: 'not_scanned' },
  [ScanStatus.Loading]: { icon: 'shield_sync_outline', tKey: 'loading', style: 'disabled' },

  // Uses default values
  [ScanStatus.Empty]: { icon: 'shield_off_outline', tKey: 'unavailable' },
  [ScanStatus.Unscanned]: { icon: 'shield_off_outline', tKey: 'unavailable' },
  [ScanStatus.Unknown]: { icon: 'shield_off_outline', tKey: 'unavailable' },
  default: { icon: 'shield_off_outline', tKey: 'unavailable' }
}
const ScanResultComponent: React.FunctionComponent<Props> = (props: Props) => {
  const { result } = props;
  const [id, setId] = useState(uniqueId('scan-result-'));

  if (result === undefined) return null;

  const iconId = `${id}-icon`;
  const tooltipId = `${id}-tooltip`;
  const map: StatusIconMapValues = get(statusIconMap, result.state, statusIconMap.default);
  const { icon, tKey, style } = map;
  const classNames = `scan-result scan-result-${result.state} scan-result-${style || 'warning'}`;

  return (
    <div className={classNames}>
      <ForgeIcon id={iconId} name={icon} aria-labelledby={tooltipId} />
      <ForgeTooltip id={tooltipId} anchor={iconId}>{t(tKey)}</ForgeTooltip>
    </div>
  );
};

export default ScanResultComponent;
